import { createSlice } from '@reduxjs/toolkit';
import type { ModalState } from 'library/types/modals';
import * as reducers from './reducers';

const initialState = {
  isAuthOpen: false,
  isNotifyOpen: false,
  notifyProps: {},
  isRecommendOpen: false,
  recommendProps: {},
  isDialogOpen: false,
  isDichotomousOpen: false,
  dialogProps: {},
  isOutOpen: false,
  isSupportOpen: false,
  isPopupVisible: false,
  popupProps: {},
  isModerationOpen: false,
  moderationProps: {},
  modalFrame: {
    isOpen: false,
    url: '',
  },
  isPaymentOpen: false,
  isActionOpen: false,
  isAddOpen: false,
} as ModalState;

export const modals = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openAuthModal: reducers.openAuthModal,
    closeAuthModal: reducers.closeAuthModal,
    openNotifyModal: reducers.openNotifyModal,
    closeNotifyModal: reducers.closeNotifyModal,
    openRecommendModal: reducers.openRecommendModal,
    closeRecommendModal: reducers.closeRecommendModal,
    openOutModal: reducers.openOutModal,
    closeOutModal: reducers.closeOutModal,
    openDialogModal: reducers.openDialogModal,
    closeDialogModal: reducers.closeDialogModal,
    openModalDichotomous: reducers.openModalDichotomous,
    closeModalDichotomous: reducers.closeModalDichotomous,
    openSupportModal: reducers.openSupportModal,
    closeSupportModal: reducers.closeSupportModal,
    openModerationModal: reducers.openModerationModal,
    closeModerationModal: reducers.closeModerationModal,
    showPopup: reducers.showPopup,
    hidePopup: reducers.hidePopup,
    toggleFrameModal: reducers.toggleFrameModal,
    openPaymentModal: reducers.openPaymentModal,
    closePaymentModal: reducers.closePaymentModal,
    openActionModal: reducers.openActionModal,
    closeActionModal: reducers.closeActionModal,
    openAddModal: reducers.openAddModal,
    closeAddModal: reducers.closeAddModal,
  },
});

export const {
  openAuthModal,
  closeAuthModal,
  openNotifyModal,
  closeNotifyModal,
  openRecommendModal,
  closeRecommendModal,
  openOutModal,
  closeOutModal,
  openDialogModal,
  closeDialogModal,
  openModalDichotomous,
  closeModalDichotomous,
  openSupportModal,
  closeSupportModal,
  openModerationModal,
  closeModerationModal,
  showPopup,
  hidePopup,
  toggleFrameModal,
  openPaymentModal,
  closePaymentModal,
  openActionModal,
  closeActionModal,
  openAddModal,
  closeAddModal,
} = modals.actions;

export {
  selectAuthOpen,
  selectOutOpen,
  selectNotifyOpen,
  selectNotifyProps,
  selectRecommendOpen,
  selectRecommendProps,
  selectDialogOpen,
  selectDialogProps,
  selectDichotomousOpen,
  selectDichotomousProps,
  selectSupportOpen,
  selectModerationOpen,
  selectModerationProps,
  selectIsPopupVisible,
  selectPopupProps,
  selectFrameModal,
  selectPaymentOpen,
  selectActionOpen,
  selectAddOpen,
} from './selectors';

export default modals.reducer;
